import { render } from "./IntegracaoVinculo.vue?vue&type=template&id=ac6abd2c"
import script from "./IntegracaoVinculo.vue?vue&type=script&lang=js"
export * from "./IntegracaoVinculo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__